module.exports = __webpack_public_path__ + "static/media/The_Hook.428cf1ac.jpeg";